/**
 * Card-to-shell channel for an accepted clarification submission.
 *
 * The card lives at the bottom of the block renderer, six components below the
 * chat model that owns message state and the stream. `WORK_STATUS_EVENT` set the
 * precedent for this: a window event costs one listener, while the alternative
 * is threading a callback through every row, slot and body component between
 * them — the same prop chain `onAgentQuestionSelect` already had to walk.
 *
 * The event carries the *open* response, not a request to make one. Submission
 * has already succeeded by the time this fires, so nothing downstream can
 * reject it and leave the card looking unanswered.
 */
export const CLARIFICATION_SUBMITTED_EVENT = 'do-chat:clarification-submitted'

export function publishClarificationSubmitted(detail) {
  if (typeof window === 'undefined' || !detail?.response) return
  window.dispatchEvent(new CustomEvent(CLARIFICATION_SUBMITTED_EVENT, { detail }))
}
